import { cssRule } from 'typestyle';

cssRule('.tb-add-ad-users-dialog', {
    width: '500px',
});

cssRule('.tb-add-ad-users-dialog .tb-multiline-text', {
    height: '50px',
});

cssRule('.tb-add-ad-users-dialog .tb-picker-container', {
    marginTop: '18px',
    height: '300px',
    marginBottom: '34px',
});

cssRule('.tb-available-quota', {
    height: '16px',
    textAlign: 'right',
});

cssRule('.tb-no-quota-available-message', {
    marginTop: '12px',
});

